import {
  SheetPageBody,
  SheetPageClose,
  SheetPageTitle,
} from "@/components/ui/sheet-page"
import Flash from "@/components/ui/flash"
import { MailPlus } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useShowProps } from "./page-props"

export default function Page() {
  const { t } = useTranslation(["invitations", "common"])
  const { listing_profile_name } = useShowProps()

  return (
    <SheetPageBody>
      <SheetPageTitle icon={MailPlus}>
        {t("invitations:invitation.title", {
          teacher_name: listing_profile_name,
        })}
      </SheetPageTitle>
      <div className="flex flex-col gap-6 p-6">
        <Flash />
        <SheetPageClose>{t("common:actions.close")}</SheetPageClose>
      </div>
    </SheetPageBody>
  )
}
